import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Button } from '@chakra-ui/react'
import { FaMagnifyingGlassPlus } from 'react-icons/fa6'

import {
    ClientFormFieldsFragment,
    ClinicFieldsFragment,
    namedOperations,
    PatientPreviewFieldsFragment,
    useAssignClientFormToPatientMutation,
} from '~graphql/generated/graphql'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'
import ClientsPatientsSearch from '~components/client-patient-search'
import { SearchModalType } from '~components/client-patient-search/types'

interface Props {
    clientForm: ClientFormFieldsFragment
    isSmall?: boolean
}

export default function FormSubmittedAssignPatientAction({
    clientForm,
    isSmall,
}: Props) {
    const { onCompleted, onError } = useToastFeedback(
        'Successfully assigned client form to patient',
        'Error assigning client form to patient',
    )

    const [assignToPatient, { loading: assignToPatientLoading }] =
        useAssignClientFormToPatientMutation({
            refetchQueries: [
                namedOperations.Query.countActionItems,
                namedOperations.Query.queryActionItems,
                namedOperations.Query.queryClientForms,
                namedOperations.Query.clientForm,
            ],
            onCompleted: () => {
                onCompleted()
            },
            onError: () => onError(),
        })

    async function handleAssignPatient(
        patient: PatientPreviewFieldsFragment | null | undefined,
        clinic: ClinicFieldsFragment | null | undefined,
    ) {
        if (!patient || !clinic) return

        await assignToPatient({
            variables: {
                id: clientForm.id,
                patientId: patient.id,
            },
        })
    }

    return (
        <ClientsPatientsSearch
            onSelect={({ patient, clinic }) =>
                handleAssignPatient(patient, clinic)
            }
            type={SearchModalType.Patient}
            customTrigger={onClick => (
                <Button
                    size={isSmall ? 'xs' : 'sm'}
                    shadow="sm"
                    colorScheme="brand"
                    leftIcon={
                        isSmall ? undefined : (
                            <Icon as={FaMagnifyingGlassPlus} />
                        )
                    }
                    isLoading={assignToPatientLoading}
                    onClick={onClick}
                >
                    Assign patient
                </Button>
            )}
        />
    )
}
